<script>
  import AuthNavbar from "../components/Navbars/AuthNavbar.svelte";
  import FooterSmall from "../components/Footers/FooterSmall.svelte";
</script>

<div class="min-h-screen bg-canvas flex flex-col">
  <AuthNavbar />
  <main class="flex-1 flex items-center justify-center px-4 pt-28 pb-16">
    <slot />
  </main>
  <FooterSmall />
</div>
